"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindAllExcessOptionsBasedOnAmount = void 0;
var _dynamicRelationshipHelpers = require("./dynamicRelationshipHelpers");
var FindAllExcessOptionsBasedOnAmount = exports.FindAllExcessOptionsBasedOnAmount = function FindAllExcessOptionsBasedOnAmount(_ref) {
  var planNumber = _ref.planNumber,
    staffMode = _ref.staffMode,
    petSureStaffMode = _ref.petSureStaffMode,
    AddOnsMap = _ref.AddOnsMap,
    AllPlans = _ref.AllPlans,
    selectedOptions = _ref.selectedOptions,
    productGroup = _ref.productGroup,
    dynamicDependencies = _ref.dynamicDependencies;
  var variantsMap = AddOnsMap[planNumber];
  var basePlan = AllPlans["Plan_".concat(planNumber)];
  var excessValidationCheck = [];
  var ExcludeStaffOnlyExcess = function ExcludeStaffOnlyExcess(excess, staffOnlyExcesses) {
    if (!petSureStaffMode && staffOnlyExcesses && staffOnlyExcesses.indexOf(excess) !== -1) {
      return true;
    }
    return false;
  };
  var baseUpmExcessOptions = basePlan.upmExcessOptions,
    staffOnlyExcesses = basePlan.staffOnlyExcesses;

  /**
   * The following function will only include excess options for the selected level of cover
   * value.
   */
  var excessOptionsBySelectedLevelOfCover = dynamicDependencies && dynamicDependencies.length > 0 ? baseUpmExcessOptions.filter(function (excessLine) {
    return excessLine.levelOfCover === parseInt(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].levelOfCover, 10);
  }) : baseUpmExcessOptions;
  var excessAmounts = excessOptionsBySelectedLevelOfCover.reduce(function (acc, _ref2) {
    var excess = _ref2.excess;
    if (excessValidationCheck.indexOf(excess) === -1 && !ExcludeStaffOnlyExcess(excess, staffOnlyExcesses)) {
      acc.push({
        label: excess,
        value: excess
      });
      excessValidationCheck.push(excess);
    }
    return acc;
  }, []);
  var variantOnlyExcessAmounts = [];

  /**
   * The following code block looks for all the plan variants for available excess options
   * based on the selected annual limit and selected level of cover.
   */
  if (variantsMap) {
    variantsMap.forEach(function (variant) {
      var variantPlanNumber = variant.planNumber;
      var _AllPlans = AllPlans["Plan_".concat(variantPlanNumber)],
        upmExcessOptions = _AllPlans.upmExcessOptions,
        limits = _AllPlans.limits;
      var availableExcessOption = dynamicDependencies && dynamicDependencies.length > 1 ? upmExcessOptions.filter(function (excessLine) {
        return excessLine.levelOfCover === parseInt(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].levelOfCover, 10) && limits.annualLimit.amount === (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].annualLimit);
      }) : upmExcessOptions;
      availableExcessOption.forEach(function (_ref3) {
        var excess = _ref3.excess;
        if (excessValidationCheck.indexOf(excess) === -1 && !ExcludeStaffOnlyExcess(excess, staffOnlyExcesses) && variantOnlyExcessAmounts.indexOf(excess) === -1) {
          excessAmounts.push({
            label: excess,
            value: excess
          });
          variantOnlyExcessAmounts.push(excess);
        }
      });
    });
  }
  if ((dynamicDependencies === null || dynamicDependencies === void 0 ? void 0 : dynamicDependencies.length) > 1) {
    var plans = (0, _dynamicRelationshipHelpers.findAllPlansWithAnnualLimit)({
      AllPlans: AllPlans,
      annualLimit: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].annualLimit,
      levelOfCover: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].levelOfCover
    });
    var excessOptions = (0, _dynamicRelationshipHelpers.findAllAvailableExcessOptions)({
      plans: plans,
      levelOfCover: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[productGroup].levelOfCover
    });
    var dynamicExcessAmounts = excessOptions.map(function (excess) {
      return {
        label: excess,
        value: excess
      };
    });
    return dynamicExcessAmounts;
  }

  // TODO: Remove below warning. Reason: In the past product table plans used to have all the excess
  // options listed in the base plans options. GLM 2.5 has introduced excess options in variant
  // plan files.
  if (variantOnlyExcessAmounts.length > 0) {
    // eslint-disable-next-line no-console
    console.error('FindAllExcessOptionsBasedOnAmount', 'Houston we have a problem. There are unique excess amounts in the product variant.');
  }
  return excessAmounts;
};